// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"Dialog_mainContainer__3NB9j","dialogButton":"Dialog_dialogButton__3aaPg","dialogTitle":"Dialog_dialogTitle__NmHub","dialogContent":"Dialog_dialogContent__3kR75"};